export default function adminPolls() {
  $(document).ready(() => {
    $.each($(".poll_poll_questions_answer_type select"), (index, selectElement) => {
      const answerType = selectElement.value;

      $.each(selectElement.options, (j, option) => {
        setQuestionTypeValue(j, selectElement, option, answerType);
      });
    });

    $.each($("#questions .question"), (index, question) => {
      const answerType = $(question)
        .find(".poll_poll_questions_answer_type select")
        .val();
      return showHideQuestionFields(question, answerType);
    });

    updateForm();

    $("form").on("cocoon:after-insert", () => {
      updateForm(); // eslint-disable-line no-undef
      initializeDropzone(); // eslint-disable-line no-undef
      return reinitializeForms(); // eslint-disable-line no-undef
    });

    $("#questions").on("cocoon:before-insert", (e, questionToBeAdded) => {
      const answerType = $("#poll_answer_type").val();
      showHideQuestionFields(questionToBeAdded, answerType);
    });
  });

  function showHideQuestionFields(questionElem, answerType) {
    const question = $(questionElem);
    const imageWrapper = question.find(".form-input-set.image");
    const limitWrapper = question.find(".form-input-set.free-text-limit");
    const freeOptions = question.find(".free-options");
    const selectElement = question.find(
      ".poll_poll_questions_answer_type select"
    )[0];

    $.each(selectElement.options, (index, option) => {
      setQuestionTypeValue(index, selectElement, option, answerType);
    });
    setPosition(question);

    switch (answerType) {
      case "five_star_with_image":
        return imageWrapper.removeClass("hidden");
      case "free_text":
        return limitWrapper.removeClass("hidden");
      case "free_options":
        return processFreeOptions(freeOptions);
      default:
    }
  }

  function setQuestionTypeValue(i, selectElem, option, answerType) {
    if (option.value !== answerType) {
      $(option).prop("disabled", true);
    } else {
      $(selectElem).prop("selectedIndex", i);
    }
  }

  function setPosition(question) {
    const positionElements = $(".poll_poll_questions_position");
    let biggestPosition = 0;
    $.each(positionElements, (index, positionElement) => {
      const positionInputValue = $($(positionElement).find("input")).val();
      const positionValue = parseInt(positionInputValue, 10);
      if (positionValue > biggestPosition) {
        return (biggestPosition = positionValue); // eslint-disable-line no-return-assign
      }
    });

    const positionElement = $(question.find(".poll_poll_questions_position")).find(
      "input"
    );
    if (positionElement.val() === "0") {
      return $(positionElement).val(biggestPosition + 1);
    }
  }

  function processFreeOptions(element) {
    element.find("input.string.disabled").removeClass("disabled");
    element.removeClass("hidden");
    return element.find("input").prop("disabled", false);
  }

  function updateForm() {
    $("a.show-link").on("click", function updateFormHandler(event) {
      event.preventDefault();
      const link = $(this);
      const siblings = link.siblings(".headings-inputs");
      siblings.toggleClass("hidden");
      siblings.find("input").first().focus();
      return link.hide();
    });
  }
}
